import React from "react";
import CardLeft from "./components/card-left.tsx";
import CardRight from "./components/card-right.tsx";
import ViewerLeft from "./components/viewer-container-left.tsx";
import ViewerRight from "./components/viewer-container-right.tsx";

const OverlayPlanViewerLayout: React.FC = () => (
    <div className="relative flex-1">
        <CardLeft />
        <CardRight />

        <div className="absolute inset-0 grid grid-cols-2 divide-x divide-gray-300">
            <ViewerLeft />
            <ViewerRight />
        </div>
    </div>
);

export default OverlayPlanViewerLayout;
